
import React, { useState, useEffect } from "react";
import AppRouter from "./routers/AppRouter";
import "normalize.css/normalize.css";
import "./styles/styles.scss";

const App = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(config => {
        window.APP_CONFIG = config; // Store globally
        setConfig(config); // Store in state
      })
      .catch(error => console.error("Error loading config:", error));
  }, []);

  if (!config) {
    return <p>Loading configuration...</p>; // Prevent rendering before config loads
  }

  return <AppRouter />;
};

export default App;











